import { render, staticRenderFns } from "./ActivitiesOperate.vue?vue&type=template&id=676f4488&scoped=true"
import script from "./ActivitiesOperate.vue?vue&type=script&lang=js"
export * from "./ActivitiesOperate.vue?vue&type=script&lang=js"
import style0 from "./ActivitiesOperate.vue?vue&type=style&index=0&id=676f4488&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676f4488",
  null
  
)

export default component.exports